/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// Public API for Zone
export {NgZone, NoopNgZone as ɵNoopNgZone} from './zone/ng_zone';
